import intlTelInput from 'intl-tel-input';

const initCreateAccountWithBloomreach = () => {
  const wrapper = document.querySelector('[data-consent-wrapper]');
  const checkboxInput = document.querySelector('#MarketingConsent');
  const phoneInput = document.querySelector('[data-signup-phone-input]');
  // Shopify Fields
  const emailInput = document.querySelector('#Email');
  const form = document.querySelector('#create_customer');

  // Conditionally show the wrapper based on the checkboxInput's checked state
  checkboxInput?.addEventListener('change', e => {
    if (e.target.checked) {
      wrapper.classList.remove('hide');
    } else {
      wrapper.classList.add('hide');
    }
  });

  // Phone Validation
  let pNum;
  if (phoneInput) {
    // setup international flag dropdwon
    pNum = intlTelInput(phoneInput, {
      nationalMode: true,
      initialCountry: window['blubolt']?.geo?.handle || 'gb',
      preferredCountries: ['gb', 'us'],
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
    });

    const errorMap = ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number'];
    const handlePhoneChange = () => {
      if (phoneInput.value.trim()) {
        phoneInput.classList.add('entered');
        if (pNum.isValidNumber()) {
          phoneInput.setCustomValidity('');
        } else {
          const errorCode = pNum.getValidationError();
          phoneInput.setCustomValidity(errorMap[errorCode]);
        }
        phoneInput.reportValidity('');
      } else {
        phoneInput.classList.remove('entered');
      }
    };

    phoneInput.addEventListener('change', handlePhoneChange);
    phoneInput.addEventListener('keyup', handlePhoneChange);
  }

  // Create customer form submission
  form?.addEventListener('submit', e => {
    e.preventDefault();

    // if checkedInput then run function with newsletter consent tracking...
    if (checkboxInput.checked) {
      const timestamp = parseInt(Date.now() / 1000);

      const identifyObject = {
        email: emailInput.value
      };

      let phoneConsentRequired = false;
      if (phoneInput.value.trim()) {
        phoneConsentRequired = true;
        identifyObject.phone = pNum.getNumber();
      }

      window['exponea'].identify({ email_id: emailInput.value }, identifyObject);

      window['exponea'].track('newsletter_signup', identifyObject);

      window['exponea'].track('consent', {
        action: 'accept',
        category: 'email',
        // eslint-disable-next-line camelcase
        valid_until: 'unlimited',
        placement: 'Footer signup',
        timestamp: timestamp
      });

      if (phoneConsentRequired) {
        window['exponea'].track('consent', {
          action: 'accept',
          category: 'sms',
          // eslint-disable-next-line camelcase
          valid_until: 'unlimited',
          placement: 'Footer signup',
          timestamp: timestamp
        });
      }

      form.submit();
    } else {
      // Continue without newsletter signup.
      form.submit();
    }
  });
};

export default initCreateAccountWithBloomreach;
